import React from "react";
const Map = () => {
  return (
    <>
      <section className="row_am map_section">
        <div className="container">
          <div className="map_inner">
            <iframe
              title="minamap"
              src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15867.390344298798!2d106.800423!3d-6.151161!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x2e69f6112d66b75d%3A0x98a549a45b31a79d!2sJl.%20Jemb.%20Besi%20VI%20No.7%2C%20RT.1%2FRW.4%2C%20Jemb.%20Besi%2C%20Kec.%20Tambora%2C%20Kota%20Jakarta%20Barat%2C%20Daerah%20Khusus%20Ibukota%20Jakarta%2011320%2C%20Indonesia!5e0!3m2!1sen!2sus!4v1740554249740!5m2!1sen!2sus"
              width="100%"
              height={510}
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default Map;
